<template>
  <button
          class="btn"
          :disabled="disabled"
          :type="type"
          @click="click" @keyup.space.prevent="click"
  >
    <slot></slot>
    <span v-if="isLoading" class="inline-block relative w-6"><span :class="spinnerClasses"></span></span>
  </button>
</template>
<script>
    export default {
        name: "my-button",
        props: {
            disabled: {type: Boolean, default: false},
            href: {type: String},
            loading: {type: Boolean, default: false},
            method: {type: String, default: "get"},
            spinnerDark: {type: Boolean, default: false},
            target: {type: String, default: ""},
            to: {type: String},
            type: {type: String, default: "button"}
        },
        data() {
            return {
                isLoading: this.loading
            };
        },
        computed: {
            spinnerClasses() {
                return this.spinnerDark ? 'spinner spinner-dark' : 'spinner';
            }
        },
        methods: {
            click() {
                if (this.isLoading) {
                    return;
                }
                if (this.target) {
                    window.open(this.href, this.target);
                    return;
                }
                if (this.to) {
                    if (this.method === 'get') {
                        this.$inertia.visit(this.to);
                    } else if (this.method === 'post') {
                        this.$inertia.post(this.to);
                    } else {
                        alert(`ERROR: Bad method=this.method`);
                    }
                    return;
                }
                if (this.href) {
                    window.location.href = this.href;
                    return;
                }
                this.$emit('click');
            },
            setLoading(loading) {
                this.isLoading = loading;
            }
        }
    }
</script>